'use strict';

var SplitCacheInMemory = require('./SplitCache/InMemory');
var SplitCacheInLocalStorage = require('./SplitCache/InLocalStorage');

var SegmentCacheInMemory = require('./SegmentCache/InMemory');
var SegmentCacheInLocalStorage = require('./SegmentCache/InLocalStorage');

var ImpressionsCacheInMemory = require('./ImpressionsCache/InMemory');
var MetricsCacheInMemory = require('./MetricsCache/InMemory');

var KeyBuilder = require('./Keys');
var KeyBuilderLocalStorage = require('./KeysLocalStorage');

/**
 * Browser storage instanciation which allows persistent strategy for segments
 * and splits.
 */
var BrowserStorageFactory = function BrowserStorageFactory(settings) {
  var storage = settings.storage;


  switch (storage.type) {
    case 'MEMORY':
      {
        var keys = new KeyBuilder(settings);

        return {
          splits: new SplitCacheInMemory(),
          segments: new SegmentCacheInMemory(keys),
          impressions: new ImpressionsCacheInMemory(),
          metrics: new MetricsCacheInMemory(),

          shared: function shared(settings) {
            return {
              splits: this.splits,
              segments: new SegmentCacheInMemory(new KeyBuilder(settings)),
              impressions: this.impressions,
              metrics: this.metrics
            };
          }
        };
      }

    case 'LOCALSTORAGE':
      {
        var _keys = new KeyBuilderLocalStorage(settings);

        return {
          splits: new SplitCacheInLocalStorage(_keys),
          segments: new SegmentCacheInLocalStorage(_keys),
          impressions: new ImpressionsCacheInMemory(),
          metrics: new MetricsCacheInMemory(),

          shared: function shared(settings) {
            return {
              splits: this.splits,
              segments: new SegmentCacheInLocalStorage(new KeyBuilderLocalStorage(settings)),
              impressions: this.impressions,
              metrics: this.metrics
            };
          }
        };
      }

    default:
      throw new Error('Unsupported storage type');
  }
};

module.exports = BrowserStorageFactory;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/storage/browser.js
// module id = 1241
// module chunks = 0